<template>
  <div class="psd-holder">

    <div class="psd-label" :class="getLabelClass">{{ getLabel }}</div>

    <div class="psd-value-holder" :class="getLabelClass">
      <div class="psd-value">{{ getValue }}</div>
    </div>

    <div class="psd-unit">{{ getUnits }}</div>
  </div>
</template>

<script>

import {useSettingsStore} from '@/store/SettingsStore';


export default {
  name: 'PrintSprinklerData',
  components: {
  },
  props: ['data', 'record'],
  data () {
    return {
      printDebug: 0,
    };
  },
  computed: {

    getSelect () {


      return this.data.value === 'plate.plateColor' ||
          this.data.value === 'diffuser.diffuser' ||
          this.data.value === 'motor.name';

          // this is temporary for nozzle since data in API wasn't available
          // this.data.value === "plateId";

    },

    getColorDot () {

      if (!this.getSelect) {
        return '';
      }
      return this.getValue;

    },
    getLabel () {
      return this.$props.data.label;
    },
    getLabelClass () {
      if (this.$props.data.type === 'subcategory') {
        return 'psd-subcategory';
      }
      if (this.$props.data.type === 'divider') {
        return 'psd-divider';
      }
    },
    getValue () {


      if (this.$props.data.label === 'Date') {
        return this.getDate(this.$props.record[this.$props.data.value]);
      }
      let v = this.record[this.$props.data.value];
      if (this.data.type !== 'divider') {
        if (v === null || v === '') { v = 'n/a'; }
      }


      if (!isNaN(v)) {
        return Number.parseFloat(v).toFixed(3);
      }

      if (v === undefined) {
        v = this.data.value;
      }

      return v;
    },
    getUnits () {
      switch (this.data.unit) {
        case 'pressure':
          return useSettingsStore().getPressureUnit;
        case 'flow':
          return useSettingsStore().getEmitterFlowUnit;
        case 'length':
          return useSettingsStore().getLengthUnit;
        default:
          return '';
      }
    },
    getRandom () {
      this.$data.printDebug++;
      return this.$data.printDebug;
    },
  },
  methods: {
    getDate (date) {
      let dateIn = Date.parse(date);
      let dateOut = new Date(dateIn);
      const dateOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      };
      return dateOut.toLocaleDateString(
        'en-US',
        dateOptions
      );
    },
  },
};
</script>

<style scoped>
.psd-holder {
  display: flex;
}
.psd-label {
  font-weight: 600;
  font-size: 13px;
  width: 100px;
  padding-right: 8px;
  border-right: 0.5px solid #adadad;
  border-bottom: 0.5px solid #adadad;
  padding-top: 5px;
  padding-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  line-height: .98em;
  text-align: right;
  white-space: pre-line;
  word-spacing: 100vw; /* Large enough to push each word onto a new line */
  line-height: 1.1em;
}
.psd-value {
  width: 120px;
  font-size: 13px;
  padding-left: 4px;
  display: flex;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;
  text-overflow: clip;
  line-height: 1.1em;
}
.psd-unit {
  font-weight: 600;
  font-size: 65%;
  display: flex;
  padding-left: 15px;
  align-items: flex-end;
}
.psd-subcategory {
  background-color: whitesmoke;
  font-weight: normal;
}
.psd-divider {
  border-top: 1px solid rgba(0, 0, 0, 0.46);
}
.psd-value-holder {
  display: flex;
  align-items: center;
  padding-left: 4px;
  border-bottom: 0.5px solid #adadad;
}
</style>
